import React, { useState } from "react";
import ReactModal from "react-modal";
import style from "../SendMerchantLink/SendMerchantLink.module.scss";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import { TextInput } from "../../../../components/form/text-input";
import { updateZohoData } from "../../../../../api";
import toast from "react-hot-toast";
import CloseIcon16 from "../../../../assets/svg/icons/common/CloseIcon16";

function EditZoho({ open, onClose, appData, getAppData, zohoIdType }) {
  const [zohoId, setZohoId] = useState(
    zohoIdType === "zoho_id" ? appData?.zoho_id : appData?.zoho_submission_id
  );
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { value } = e.target;
    setZohoId(value);
    setError("");
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    setError("");

    const data = {
      id: appData.id,
      [zohoIdType === "zoho_id" ? "zoho_id" : "zoho_submission_id"]: zohoId,
      zohoIdType: zohoIdType === "zoho_id" ? "zoho_id" : "submission_id",
    };

    const toastId = toast.loading("Updating...");
    try {
      const response = await updateZohoData(data);
      
      if (response.status) {
        toast.success("Updated successfully!", { id: toastId });
        getAppData();
        onClose();
      } else {
        toast.error(response.message || "Failed to update", { id: toastId });
        setError(response.message || "Failed to update");
      }
    } catch (err) {
      toast.error("Something went wrong!", { id: toastId });
      setError("Something went wrong!");
    }

    setIsLoading(false);
  };

  return (
    <ReactModal isOpen={open} className={style.react_modal} ariaHideApp={false}>
      <div className={style.header}>
        <ButtonIcon onClick={onClose}>
          <CloseIcon16 />
        </ButtonIcon>
      </div>

      <div className={style.body}>
        <h6>Edit {zohoIdType === "zoho_id" ? "Zoho ID" : "Submission ID"}</h6>

        <div className={style.form_group}>
          <TextInput
            id={zohoIdType}
            name={zohoIdType}
            label={zohoIdType === "zoho_id" ? "Zoho ID" : "Submission ID"}
            value={zohoId || ""}
            onChange={handleChange}
            placeholder={`Enter ${
              zohoIdType === "zoho_id" ? "Zoho ID" : "Submission ID"
            }`}
            errored={!!error}
            error={error}
          />
        </div>
      </div>

      <div className={style.footer_modal}>
        <div className={style.button_group}>
          <ButtonIcon textColor="#254FE2" onClick={onClose}>
            Cancel
          </ButtonIcon>
          <ButtonIcon
            bgColor={"#4C70EF"}
            textColor="#FFF"
            isLoading={isLoading}
            disabled={!zohoId}
            onClick={handleSubmit}
          >
            Update
          </ButtonIcon>
        </div>
      </div>
    </ReactModal>
  );
}

export default EditZoho; 